import { MessageBox } from "element-ui";
const promptModal = (
  title,
  text,
  btnText,
  successCallback = null,
  errorCallback = null,
  cancelText = "Cancel"
) => {
  const textToDisplay = text
    ? text
    : "This will permanently delete the file. Continue?Delete Device";
  const titleToDisplay = title || "Delete Item";
  MessageBox.confirm(textToDisplay, titleToDisplay, {
    confirmButtonText: btnText || "Delete",
    cancelButtonText: cancelText,
    iconClass: "",
    type: "",
    cancelButtonClass: "btn blue-border btn-full-radius",
    confirmButtonClass: "btn btn-blue btn-full-radius",
    title,
  })
    .then(() => {
      if (successCallback) {
        successCallback();
      }
    })
    .catch(() => {
      if (errorCallback) {
        errorCallback();
      }
    });
};

export default promptModal;
